module.exports = __webpack_public_path__ + "static/media/m_beard_medium_long__square_shadow.41031c3e.png";